import { directiveResolveParams } from '../util';
export default {
    // called before bound element's attributes
    // or event listeners are applied
    created(el, binding, vnode, prevVnode) {
    },
    // called right before the element is inserted into the DOM.
    beforeMount(el, binding, vnode, prevVnode) {},
    // called when the bound element's parent component
    // and all its children are mounted.
    mounted(el, binding, vnode, prevVnode) {
        let actionToggle = el.querySelector(directiveResolveParams(el, binding, 'actionToggle','.form-read-more'));
        let actionTextHide = directiveResolveParams(el, binding, 'textHide',actionToggle.innerText);
        let actionTextShow = directiveResolveParams(el, binding, 'textShow', actionToggle.innerText);
        el.classList.add('with-read-more');

        actionToggle.addEventListener('click', function(event){
            if(el.classList.contains('with-read-more')){
                el.classList.remove('with-read-more');
                actionToggle.innerText = actionTextShow;
            } else {
                el.classList.add('with-read-more');
                actionToggle.innerText = actionTextHide;
            }
        })
    },
    // called before the parent component is updated
    beforeUpdate(el, binding, vnode, prevVnode) {},
    // called after the parent component and
    // all of its children have updated
    updated(el, binding, vnode, prevVnode) {},
    // called before the parent component is unmounted
    beforeUnmount(el, binding, vnode, prevVnode) {},
    // called when the parent component is unmounted
    unmounted(el, binding, vnode, prevVnode) {}
}
